import { cn } from "@/lib/utils";
import { CardLoader } from "./luxury-loader";

interface ContentFallbackProps {
  type?: 'page' | 'section' | 'card';
  count?: number;
  className?: string;
}

export function ContentFallback({ type = 'section', count = 1, className }: ContentFallbackProps) {
  if (type === 'page') {
    return (
      <div className={cn("min-h-[400px]", className)}>
        <CardLoader message="Loading content..." />
      </div>
    );
  }

  if (type === 'card') {
    return (
      <div className={cn("space-y-4", className)}>
        {Array.from({ length: count }).map((_, i) => (
          <CardLoader key={i} />
        ))}
      </div>
    );
  }

  return (
    <div className={cn("space-y-4", className)}>
      <CardLoader message="Loading section..." />
    </div>
  );
}
